const invoiceorder = {
    getlist: 'invoiceorder/getlist',
    add: 'invoiceorder/add',
    update: 'invoiceorder/update',
    remove: 'invoiceorder/remove',
    get: 'invoiceorder/get',
    getall: 'invoiceorder/getall',
    clearcache: 'invoiceorder/clear-cache',
    refresh: 'invoiceorder/refresh',
}
export default invoiceorder
